
export default {
  statusCodes: {
    NOT_FOUND: 'NOT_FOUND',
    OK: 'OK'
  },
  store: {
    SETTING: 'setting',
    CLIENTS: 'clients',
    EVENTS: 'events',
    EMAIL_HISTORY: 'emailHistory'
  }
};



// WEBPACK FOOTER //
// ./src/store/constants.js